import { checkoutReducer } from '../../checkout/reducers/CheckoutReducer';
import checkoutSaga from '../../checkout/sagas/CheckoutSagas';
const loadCheckoutModule = () => ({
    id: 'Checkout',
    reducerMap: {
        checkout: checkoutReducer,
    },
    sagas: [checkoutSaga],
});
export default loadCheckoutModule;
